(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').directive('mxPieChart', MxPieChartDirective);

	MxPieChartDirective.$inject = ['$injector', 'mx.SolutionBuilderAgent.BaseChartService'];

	function MxPieChartDirective($injector, baseChartService) {
		var directive = baseChartService.mxBaseChartDirective($injector);

		directive.controller = MxPieChartCtrl;
		return directive;
	}

	MxPieChartCtrl.$inject = ['$injector', '$controller', '$scope', '$attrs', '$element', 'mx.SolutionBuilderAgent.BaseChartService'];
	function MxPieChartCtrl($injector, $controller, $scope, $attrs, $element, baseChartService) {
		var vm = $controller('mx.SolutionBuilderAgent.MxBaseChartController', {
			$injector: $injector,
			$scope: $scope,
			$attrs: $attrs,
			$element: $element,
		});

		vm.getChartConfig = function () {
			return baseChartService.getBaseChartConfig(vm).then(function (baseConfig) {
				var config = angular.extend({}, baseConfig);
				config.chart.type = 'pie';
				config.plotOptions.pie = {
					dataLabels: {
						enabled: Boolean(vm.labelsFormat),
						format: vm.labelsFormat || undefined,
					},
					showInLegend: vm.legendVisible === 'true',
				};
				return config;
			});
		};

		return vm;
	}
})();
